import { GetLargestButtonSize } from './button.types'

const BUTTON_SIZE_MEDIUM = 'medium'
const BUTTON_SIZE_LARGE = 'large'

export const getLargestButtonSize: GetLargestButtonSize = ({ large }) => (
  large
    ? BUTTON_SIZE_MEDIUM
    : BUTTON_SIZE_LARGE
)
